
import {Component, Prop, Vue} from 'vue-property-decorator'
    import {getMerchantsTagList, TagListDto} from "@/api/customerManage";

    @Component({
        name: 'LabelFilters'
    })
    export default class LabelFilters extends Vue {
        @Prop({default: false}) isMultiple!: boolean // 是否多选
        @Prop({default: true}) isShowAll!: boolean // 是否显示所有标签
        @Prop({default: true}) isShowReset!: boolean // 是否显示清空
        @Prop({default: false}) isShowAdd!: boolean // 是否直接显示新增按钮
        @Prop({default: true}) isShowSetting!: boolean // 是否直接显示设置按钮
        @Prop({default: '客户标签筛选'}) title!: boolean // 标题
        @Prop({default: false}) isShop!: boolean // 是否是企业商城的设置

        showTemp = false
        companyId = ''
        tagList: TagListDto[] = []
        tags: TagListDto[] = [] // 选中的标签列表

        mounted () {
            this.$eventBus.$on('labelAdd', (id: string) => {
                getMerchantsTagList({companyId: this.companyId}).then((res) => {
                    this.tagList = res.data.tagList || []
                    const index = this.tagList.findIndex(item => { return item.tagId === id })
                    if (index > -1) {
                        this.tags.push(this.tagList[index])
                    }
                    this.sureFunc()
                })
            })
        }

        getTagList () {
            getMerchantsTagList({companyId: this.companyId}).then((res) => {
                this.tagList = res.data.tagList || []
            })
        }

        show (options: { companyId: string, tags: TagListDto[] }) {
            this.companyId = options.companyId
            this.tags = options.tags || []
            this.getTagList()
            this.showTemp = true
        }

        hide () {
            this.showTemp = false
        }

        sureFunc () {
            this.$emit('getTagId', this.tags)
            this.hide()
        }

        resetFunc () {
            this.tags = []
            this.$emit('getTagId', this.tags)
            this.hide()
        }

        changeTag (val: TagListDto) {
            if (!val) return this.tags = []
            if (this.isMultiple) {
                if (this.tags.findIndex(item => {return item.tagId === val.tagId}) > -1) {
                    this.tags = this.tags.filter(item => item.tagId !== val.tagId)
                } else {
                    this.tags.push(val)
                }
            } else {
                this.tags = [val]
            }
        }

        toSetting () {
            if(this.isShop){
              this.$router.push('/shopLabelSetting')
            }else{
              this.$router.push('/labelSetting')
            }
        }

        toAdd () {
            this.showTemp = false
            this.$router.push({
                path: '/labelHandle',
                query: {
                    isAdd: '1'
                }
            })
        }

        destroyed () {
            this.$eventBus.$off('labelAdd')
        }
    }
